export function colorCheck(color) {
  switch (color) {
    case "teal":
      return "teal-dark";
    case "green":
      return "accessible-green";
    case "orange":
      return "orange-dark";
    default:
      return color;
  }
}
